import React, { useEffect, useState } from 'react'

import { StyleSheet, Platform, Keyboard, View } from 'react-native'
import { KeyboardAwareScrollView } from '../Components'

import { useFormik } from 'formik'
import * as Yup from 'yup'
import delay from 'delay'

import {
  Description,
  Space,
  TextInputExtended,
  Button,
  ReturnFooter
} from '@sart/components'
import { prettyErrorMessage } from '@sart/utilities'
import { adaptive, typography, colors } from '@sart/styles'
import client, { useClient, useData } from '@sart/client'
import { useContent} from '@sart/content'
import { testID } from '@sart/utilities'
import * as theme from '../Sign/signTheme'

export default function ProfileAddress(props) {
  const { navigation } = props

  const [{ settings, loading, error }, setData] = useData({ loading: true})
  const [updateProduct, setUpdateProduct] = useState({})
  const content = useContent()

  const {
    cache: {
      customer,
    } = {}
  } = useClient()

  const homeAddress = customer ? customer.homeAddress : undefined

  useEffect(() => void fetchProduct(),[])
  //TODO these values will come from the customer when it is implemented
  const formik = useFormik({
    initialValues: {
      address1: homeAddress ? (homeAddress.addressLine1 || '') : '',
      address2: homeAddress ? (homeAddress.addressLine2 || '') : '',
      city: homeAddress ? (homeAddress.city || '') : '',
      county: homeAddress ? (homeAddress.state || '') : '',
      postcode: homeAddress ? (homeAddress.zip || '') : ''
    },
    validationSchema: Yup.object().shape({
      address1: Yup.string().required(content.forms.required).test('validate-address-1', content.profile_address.noSpecialCharacters, value => blockSpecialCharacters(value)),
      address2: Yup.string().test('validate-address-1', content.profile_address.noSpecialCharacters, value => blockSpecialCharacters(value)),
      city: Yup.string().required(content.forms.required).test('validate-address-1', content.profile_address.noSpecialCharacters, value => blockSpecialCharacters(value)),
      county: Yup.string().test('validate-address-1', content.profile_address.noSpecialCharacters, value => blockSpecialCharacters(value)),
      postcode: Yup.string().trim().required(content.forms.required).test('postcode-check', content.profile_address.validPostcode, value => validatePostcode(value))
    }),
    onSubmit: handleSubmit
  })

  function blockSpecialCharacters(value) {
    if(value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-,.]+$/)) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  function validatePostcode(value) {
    if(value) {
      return value.match(/^\d{5}$/)
    } else {
      return true
    }
  }

  async function fetchProduct() {

    try {
      var updateProducts = await client.callApi('catalog','getUpdatePersonalDetails',[client.cache.catalogId])
      setUpdateProduct(updateProducts[0])
      setData({ loading: false })
    } catch (error) {
      setData({ loading: false, error })
    }
  }

  function detailsHaveChanged(values){
    return customer.homeAddress.addressLine1 !== values.address1 ||
           customer.homeAddress.addressLine2 !== values.address2 ||
           customer.homeAddress.city !== values.city ||
           customer.homeAddress.state !== values.county ||
           customer.homeAddress.zip !== values.postcode
  }

  async function handleSubmit(values, form) {
    Keyboard.dismiss()
    console.log('submitting address')
    console.log('we have a product: ' + JSON.stringify(updateProduct))
    form.setSubmitting(true)
    //create the extended data for the product
    if (detailsHaveChanged(values)){
      var extendedData = {}
      extendedData.serviceLegacyId = client.cache.serviceLegacyId
      if (customer.homeAddress.addressLine1 !== values.address1){
        customer.homeAddress.addressLine1 = values.address1
        extendedData.addressLine1 = values.address1
      }

      if (customer.homeAddress.addressLine2 !== values.address2){
        customer.homeAddress.addressLine2 = values.address2
        extendedData.addressLine2 = values.address2
      }
      if (customer.homeAddress.city !== values.city){
        customer.homeAddress.city = values.city
        extendedData.city = values.city
      }
      if (customer.homeAddress.state !== values.county){
        customer.homeAddress.state = values.county
        extendedData.state = values.county
      }

      if (customer.homeAddress.zip !== values.postcode){
        customer.homeAddress.zip = values.postcode
        extendedData.zip = values.postcode
      }
      try {
        
         // Originally newCode variable. Changed it. Not sure if this is the solution.
          
          var order = await client.checkoutCustomerProductNoPayment(updateProduct,extendedData)
          if (order.status === "failed"){
            //order failed, throw an exception to be caught
            throw new Error(content.menu.orderFailed)
          
        }
  
        let updatedCustomer = await client.callApi('customer','getCustomer',[customer.customerId])
        console.log('updated customer is: ')
        console.log(JSON.stringify(updatedCustomer,null,2))
        client.setCache({customer: updatedCustomer})
        navigation.navigate('Account')

      } catch (error) {
      const message = prettyErrorMessage(error, 'profileAddress', content)
      form.setFieldError('vat', message)
      form.setSubmitting(false)
      }
    } else {
      form.setSubmitting(false)
    }
  }
  var address2Ref, cityRef, countyRef, postCodeRef;

  return (
    <KeyboardAwareScrollView style={styles.container}>
      <View style={styles.wrapper}>

      <Description style={styles.description}>{content.profile_address.description}</Description>

      <Space height={24} />

      <TextInputExtended
        label={content.forms.address1Label}
        value={formik.values.address1}
        placeholder={content.forms.address1Placeholder}
        {...Platform.select({
          web: { autoComplete: "address-line1" },
          ios: { textContentType: "streetAddressLine1" },
          android: { autoCompleteType: "street-address" }
        })}
        onChangeText={formik.handleChange('address1')}
        onBlur={formik.handleBlur('address1')}
        error={formik.touched.address1 && formik.errors.address1}
        style={styles.inputText}
        onSubmitEditing={() => this.address2Ref.focus()}
        returnKeyType="next"
        labelStyle={styles.label}
        selectionColor={colors.common}
        {...theme.textInputWhiteBackground}
        {...testID('address1')}
      />

      <Space height={8} />

      <TextInputExtended
        label={content.forms.address2Label}
        value={formik.values.address2}
        placeholder={content.forms.address2Placeholder}
        onChangeText={formik.handleChange('address2')}
        onBlur={formik.handleBlur('address2')}
        error={formik.touched.address2 && formik.errors.address2}
        style={styles.inputText}
        // ref={ref => {
        //   this.address2Ref = ref;
        // }}
        onSubmitEditing={() => this.cityRef.focus()}
        returnKeyType="next"
        labelStyle={styles.label}
        selectionColor={colors.common}
        {...theme.textInputWhiteBackground}
        {...testID('address2')}
      />

      <Space height={8} />

      <TextInputExtended
        label={content.forms.cityLabel}
        value={formik.values.city}
        placeholder={content.forms.cityPlaceholder}
        {...Platform.select({
          web: { autoComplete: "address-level2" },
          ios: { textContentType: "addressCity" }
        })}
        onChangeText={formik.handleChange('city')}
        onBlur={formik.handleBlur('city')}
        error={formik.touched.city && formik.errors.city}
        style={styles.inputText}
        // ref={ref => {
        //   this.cityRef = ref;
        // }}
        onSubmitEditing={() => this.countyRef.focus()}
        returnKeyType="next"
        labelStyle={styles.label}
        selectionColor={colors.common}
        {...theme.textInputWhiteBackground}
        {...testID('city')}
      />

      <Space height={8} />

      <TextInputExtended
        wrapperStyle={styles.nestedInputs}
        label={content.forms.countyLabel}
        value={formik.values.county}
        placeholder={content.forms.countyPlaceholder}
        {...Platform.select({
          web: { autoComplete: "address-level11" },
          ios: { textContentType: "addressState" }
        })}
        onChangeText={formik.handleChange('county')}
        onBlur={formik.handleBlur('county')}
        error={formik.touched.county && formik.errors.county}
        style={styles.inputText}
        // ref={ref => {
        //   this.countyRef = ref;
        // }}
        returnKeyType="next"
        onSubmitEditing={() => this.postCodeRef.focus()}
        labelStyle={styles.label}
        selectionColor={colors.common}
        {...theme.textInputWhiteBackground}
        {...testID('county')}
      />

      <Space height={8} />

      <TextInputExtended
        wrapperStyle={styles.nestedInputs}
        label={content.forms.postcodeLabel}
        value={formik.values.postcode}
        placeholder={content.forms.postcodePlaceholder}
        autoCorrect={false}
        {...Platform.select({
          web: { autoComplete: "postal-code" },
          ios: { textContentType: "postalCode" },
          android: { autoCompleteType: "postal-code" }
        })}
        onChangeText={formik.handleChange('postcode')}
        onBlur={formik.handleBlur('postcode')}
        error={formik.touched.postcode && formik.errors.postcode}
        style={styles.inputText}
        // ref={ref => {
        //   this.postCodeRef = ref;
        // }}
        returnKeyType="go"
        onSubmitEditing={formik.handleSubmit}
        labelStyle={styles.label}
        selectionColor={colors.common}
        {...theme.textInputWhiteBackground}
        {...testID('postcode')}
      />

      <Space height={24} />

      <Button
        title={content.profile_address.submit}
        disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
        onPress={formik.handleSubmit}
        titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
        disabledTitleStyle={{...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45}}             
        style={styles.enabledStyle}
        disabledStyle={styles.disabledStyle}
        {...testID('addressSubmit')}
      />

      </View>
    </KeyboardAwareScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    ...adaptive.wrapperPadding,
    backgroundColor: colors.white
  },
  wrapper: {
    paddingTop: 24,
    paddingBottom: 24,
  },
  enabledStyle: {
    backgroundColor: colors.srDarkGreen
  },
  disabledStyle: {
    backgroundColor: colors.srDarkGreen + 60,
    borderColor: colors.srGreen,
    borderWidth: 1
  },
  description: {
    textAlign: "center",
    ...typography.lightbold,
    color: colors.srGreen
  },
  inputText: {
    ...typography.demi,
    borderColor: colors.srGreen
  },
  titleStyle: {
    ...typography.extrabold, 
    fontSize: 18
  },
  label: {
    color: colors.srGreen,
  },
})
